import React from 'react'

const mainContent = (props) => (
  <div className="content-wrapper" style={{ height: '100%' }}>
    {props.children}
  </div>
)

export default mainContent
